import { displayMessage } from "../../../../helpers/messages";

const exercise_grid_columns = [
    {
        field: "id",
        headerName: displayMessage("ID"),
        flex: 0.4,
        minWidth: 60,
    },
    {
        field: "name",
        headerName: displayMessage("EXERCISE_NAME"),
        flex: 2.5,
        minWidth: 220,
    },
    {
        field: "sets",
        headerName: displayMessage("SETS"),
        flex: 0.5,
        minWidth: 80,
        renderCell: (params) => params.value ?? "-",
    },
    {
        field: "reps",
        headerName: displayMessage("REPS"),
        flex: 0.8,
        minWidth: 100,
        renderCell: (params) => params.value || "-",
    },
    {
        field: "rest_seconds",
        headerName: displayMessage("REST_SECONDS"),
        flex: 0.8,
        minWidth: 100,
        renderCell: (params) => {
            if (!params.value) return "-";
            return `${params.value}s`;
        },
    },
    {
        field: "video_url",
        headerName: displayMessage("VIDEO_URL"),
        flex: 1.5,
        minWidth: 140,
        renderCell: (params) => {
            if (!params.value) return "-";
            return (
                <a
                    href={params.value}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-500 underline truncate"
                >
                    Ver vídeo
                </a>
            );
        },
    },
];

export default exercise_grid_columns;
